export default {
  resetPasswordEmail: "Reset password email",
  activeSuccess: "Your account has been successfully activated!",
  activingYourEmail: "We are verifying your email address.",
  addNewArticle: "Add a new chapter",
  allEvents: "What's on Unicapsule",
  alreadyActived:
    "Activation has been successful. Redirecting you back to sign in...",
  alreadyBeenTaken: "already exists",
  alreadyRegistered: "Sorry, this email address is already registered.",
  back: "Back",
  backToHome: "Back to home",
  bookNeedPassword: "Need the access code to view the book",
  bookSettings: "Settings",
  cancel: "Cancel",
  changeAvatar: "Change your avatar",
  changePassword: "Change your password",
  clickToSignin: "Click here to sign in",
  code: " link",
  commentDeleted: "Oops, this comment no longer exists.",
  createBookButton: "Create ",
  createNewBook: "Create a new Book",
  delete: "Delete",
  deleteArticleConfirm: "Are you sure you want to delete the chapter?",
  deleteArticleMessage:
    "The chapter will be moved to the Trash, and no one else will be able to see it.",
  edit: "Edit",
  editArticleTitle: "Edit chapter",
  editLink: "rename link",
  emailAddress: "Email address",
  emailNotFound: "The email address provided is not registered.",
  emailRegisteredButNotActived:
    "An activation email has been sent to your registered email address. Your account is waiting to be activated.",
  emailSendSuccess: "Email sent successfully",
  empty: "You forgot to enter ",
  eventList: "All events.",
  eventListTitle: "What's on Unicapsule",
  favorite: "Like it!",
  fileMaxSizeExceed: "Maximum upload file size: {size}KB",
  fileNumberSizeExceed: "Maximum number of files allowed: {number}",
  uploadingFile: "Uploading file, please wait...",
  findPasswordButton: "Reset password",
  findPasswordTitle: "Forgot password",
  forgotPassword: "Forgot your password?",
  Go: "Go",
  helloMessage:
    "Hi {email} Welcome to Unicapsule! It's great to have you with us! Please customize your profile to get started.",
  ifActiveEmailNotReceived: "Didn't receive your account activation email?",
  isAllowCoWrite: "Do you allow your friends to write with you?",
  isPublic: "Shared with public",
  languageSelect: "Language",
  leaveComment: "Add a comment.",
  linkCopied: "Link copied to your clipboard.",
  linkToInviteCollaborators: "Invite your friends with the link below.",
  mailSendFailed: "Email sending failed, please try again...",
  mustWriteSth: "Please write something for your book",
  newArticle: "A new chapter has been added to the book.",
  newComment: "A new comment was posted.",
  newBook: "New Book",
  username: "Username",
  noContent: "No content found",
  noNotice: "You have no new messages",
  noSuchUser: "Oops, user does not exist.",
  notAllowSpecialCharacters:
    "Pease don't use symbols, punctuations, or spaces.",
  nothingToView: "Oops, page not found.",
  notification: "Message",
  okStart: "OK Let's start!",
  onlyAcceptFileType: "Allowed file types: {format}",
  pageNotFound: "Not found",
  pageNotFoundDesp:
    "Sorry, my friend. The URL you requested could not be found.",
  password: "Password",
  passwordCorrect: "Code correct! The book is opening ...",
  passwordNotSame: "Passwords do not match.",
  passwordProtection: "Access code required.",
  passwordResetSuccess: "Password reset successful",
  postComment: "Post",
  publishArticle: "Submit chapter",
  randomPassword: "Auto-generate",
  resetPassword: "Reset password",
  retry: "Retry",
  saveArticle: "Publish",
  saveAsDraft: "Save Draft",
  saveAvatar: "Save avatar",
  saveBookChanges: "Save book",
  saveFailed: "Save failed, please try again later.",
  saveLink: "Save link",
  saveUsername: "Save username",
  savePassword: "Save password",
  saveSuccess: " save successfully",
  seeAllNotification: "All messages",
  setBookPassword: "Set access code",
  setNewPasswordTitle: "Change password",
  setUsername: "Set your username",
  settings: "Profile",
  signin: "Sign in",
  signInTitle: "Sign in",
  signInToSubmit: "Sign in to create your book",
  signup: "Sign up",
  signUpTitle: "Sign up",
  signOut: "Sign out",
  submit: "Submit",
  submitClosed: "Submission closed",
  title: "Title",
  tooLong: " must be no more than {len} characters",
  tooShort: " must be at least {len} characters",
  typeBookPasswordHere: "Please enter access code.",
  typeBookTitleHere: "Please enter a title",
  typeEmailHere: "Enter your emial address here...",
  typeNewCodeHere: "Enter your new access code.",
  typePassword: "Enter password",
  typePasswordHere: "Enter your password here...",
  typeValidEmail: "This doesn't look like an email address ...",
  unFavorite: "Unlike",
  unicapsule: "Unicapsule",
  updateProfile: "Profile settings",
  uploadAvatar: "Upload avatar",
  uploadBookCover: "Upload your cover",
  uploadFailed: "Upload failed, please try again later.",
  views: "views",
  writeSthHere: "leave something here for a little surprise",
  wrongAccessCode: "access code incorrect",
  wrongPassword: "You have entered an incorrect password, please try again.",
  zoomIn: "Zoom In",
  typeNewBookPasswordHere: "Enter your new access code.",
  book: "Public Books",
  eventEndAt: "Sorry, we are closed.",
  comment: "comment",
  commentBeenDeleted: "Your comment has been removed.",
  authing: "Activating your account, please wait.",
  thirdPartyRegistered: "The email address has been registered with {provider}",
  or: " or ",
  thirdPartyLogin: "Sign in with {provider}",
  pleaseWait: "Please wait.",
  repeatPasswordHere: "repeat password",
  newPasswordLogin:
    "Congratulations! Your password has ben reset. Please sign in using your new password.",
  resetLinkExpired: "Ooops, the link has expired.",
  avatar: "avatar",
  copyLink: "Copy Link",
  createdBook: "Created book",
  joinedBook: "Joined book",
  createdArticle: "Created chapter",
  favedBook: "Liked Book",
  favedArticle: "Liked chapter",
  deleteCommentConfirm: "Are you sure you want to remove the comment?",
  deleteCommentMessage: "Removed comments are not recoverable.",
  activeEmail: "Activation email",
  emailSent: " sent successfully.",
  emailInstruction: "Please follow the instructions in the email.",
  emailSending: ", please wait",
  clickHere: "Click here",
  resendEmail: " to re-send ",
  to: " to ",
  skipActivation:
    "Didn't receive the email? No worries, let's sign in to have a look!",
  activeEventList: "Latest events",
  userNameDuplicated: "The username has already been taken",
  networkError: "The network connection flake out",
  serverCommunicateFaild:
    "Our server is temporarily unable to service your request. Please try again later.",
  restPasswordInstruction1:
    "We've sent an email to you with instructions for how to reset the password.",
  restPasswordInstruction2:
    "Didn't receive the password reset email? Please check your spam folder. If you still can't see the email, please refresh to try again.",
  articleNotSaved: "Save before you go?",
  articleNotSavedMessage:
    "It looks like you're in the middle of writing something and you haven't save them",
  discard: "Discard",
  refresh: "Refresh",
  oldLinkVanished: "This link is unique and will be replaced once renamed. ",
  hasNewBook: "{number} new books",
  commentDeletedBy: "{name} removed your comments",
  continueWithoutSign: "Go to Unicapsule",
  typeValidLink: "This doesn't look like an link ...",
  link: "link",
  insertLinkImgError: "",
  getPostionFailed:
    "failed to get your current position, please try again later",
  getWeatherFaild: "failed to get weather information, please try again later",
  eventEndTip: "the event has been closed, come earlier next time",
  readMore: "read more",
  widthOrigin: "original",
  rotateRight: "right",
  rotateLeft: "left",
  maxWidth: "width :",
  pintop: "Sticky",
  cancelPintop: "cancel sticky",
  pullDownToRefresh: "pull down to refresh",
  releaseToRefresh: "release to refresh",
  pullUpToLoad: "pull up to load more",
  loadCompleted: "load completed",
  mineHome: "home page",
  facebook: "Facebook",
  weibo: "Weibo",
  wechatShare: "Wechat",
  emailShare: "Email",
  openImage: "open image",
  draftArticle: "drafts",
  googleLoginFailed: "cannot get google auth info, please resiger again",
  advanceSetting: "advanced setting",
  inviteFriends: "invite friends",
  inviteFriendsPlaceholder: "invite friends by email address",
  invatationLetter: "invatation letter",
  cardStyle: "card style",
  typeBookIntroHere: "some short description for this book",
  activeEmailSendSuccess: "Email sent successfully",
  canUpload: "VIP user can upload {number} images",
  IndexPage: "Index",
  LoginPage: "Login",
  RegPage: "Register",
  CreatePage: "Creating new book",
  EditBookPage: "Edit",
  EventPage: "Evnet",
  EventViewPage: "",
  EventArticleListPage: "",
  BookViewPage: "Book details",
  BookPage: "Book details",
  AddArticlePage: "Writing",
  HomeDefaultPage: "Home",
  HomeCreatedBookPage: "My books",
  HomeFavedBookPage: "Favorited books",
  HomeJoinedBookPage: "Joined books",
  HomeCreatedArticlePage: "My books",
  HomeFavedArticlePage: "Favorited books",
  HomeDraftArticlePage: "Drafts",
  SettingPage: "Profile",
  ProfilePage: "Profile",
  EmailActivationPage: "Actication",
  ActivationPage: "Activation",
  ArticleViewPage: "Book details",
  ArticleViewByBookPage: "Book details",
  ArticleEditPage: "Edit",
  ForgotPasswordPage: "Forgot password",
  ResetPasswordPage: "reset password",
  AuthPage: "one moment...",
  AuthCallbackPage: "one moment...",
  "404Page": "404 NOT FOUND",
  notFoundPage: "NOT FOUND",
  invite: "Invite Friends",
  sendInvite: "Send Invation",
  cannotInviteYouself: "This is your email.",
  invaiteSendSuccessed: "Invation send successfully",
  inviteSuccessed: "Invation send successfully",
  inviteFailedEmail: "Invalid email address",
  management: "My content",
  HomeCreatedBook: "created books",
  HomeFavedBook: "favorited books",
  HomeJoinedBook: "joined books",
  HomeCreatedArticle: "created books",
  HomeFavedArticle: "favorited books",
  HomeDraftArticle: "drafts",
  privateBook: "private books",
  invatationLetterContent: "",
  downloadQrcode:'download',
  eventMemberSum: '{sum} articles added',
  eventCountdown:' till event ended',
  eventOpenDateCountdown:' till event open',
  event:'Events',
  eventArticleList:'Articles list',
  addNewArticleToEvent:'Add new artile'
};
